import { IServiceData, IHourType, IDayData } from './typing';

export const services: IServiceData[] = [
  {
    id: 1,
    name: 'reboque_car',
    label: 'Reboque Leve',
    code: 'ser-77362873760431',
  },
  {
    id: 2,
    name: 'reboque_moto',
    label: 'Reboque Moto',
    code: 'ser-77362873760431',
  },
  {
    id: 3,
    name: 'reboque_suv',
    label: 'Reboque Utilitário',
    code: 'ser-77362873760431',
  },
  {
    id: 4,
    name: 'drypan',
    label: 'Pane Seca',
    code: 'ser-71595200104160',
  },
  {
    id: 5,
    name: 'keychain',
    label: 'Chaveiro Automotivo',
    code: 'ser-58133848228926',
  },
  {
    id: 6,
    name: 'battery_recharge',
    label: 'Recarga de Bateria',
    code: 'ser-49183601941352',
  },
  {
    id: 7,
    name: 'tire_change',
    label: 'Troca de Pneu',
    code: 'ser-22771391723840',
  },
];

export const hour_types_select: IHourType[] = [
  {
    label: 'Horário fixo',
    value: 'fixed_hour',
  },
  {
    label: '24 horas',
    value: '24_hour',
  },
];

export const daysOfWeek: IDayData[] = [
  {
    id: 1,
    value: 'util_day',
    label: 'Segunda à sexta',
  },
  {
    id: 2,
    value: 'saturday',
    label: 'Sabado',
  },
  {
    id: 3,
    value: 'sunday',
    label: 'Domingo',
  },
];
